import React, { useCallback, useEffect, useState, useRef } from "react";
import { useError } from "../../context/errorContext";
import CloseIcon from '@mui/icons-material/Close';
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';
import RemoveCircleOutlineOutlinedIcon from '@mui/icons-material/RemoveCircleOutlineOutlined';
import axiosInstance from "../../api/axiosInstance";
import useModalClose from "../../hooks/useModalClose";
import "../changePermissions/changePermissions.scss";
import moment from 'moment';

const ChangePermissions = ({ imei, onClose }) => {
    const [isLoading, setLoading] = useState(true);
    const [permissions, setPermissions] = useState([]);
    const [role, setRole] = useState("");

    const containerRef = useRef(null);

    useModalClose(containerRef, onClose);

    const { showMessage } = useError();

    const fetchData = useCallback(async () => {
        try {
            const [permissionsRes] = await Promise.all([
                axiosInstance.get(`permissions/${imei}`)
            ]);

            setPermissions(permissionsRes.data);
            setLoading(false);
        } catch (err) {
            console.error(err);
        }
    }, [imei]);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    const handleAddPermissions = async () => {
        try {
            await axiosInstance.post(`permissions`, { imei, role });
            showMessage("Rechte geändert!");
            setRole("");
            fetchData();
        } catch (err) {
            console.error(err);
            showMessage("Fehler beim Hinzufügen!");
        }
    };

    const handleDeletePermissions = async ({ id }) => {
        try {
            await axiosInstance.delete(`permissions/${id}`);
            showMessage("Rechte entfernt!");
            fetchData();
        } catch (err) {
            console.error("Fehler beim Löschen der Rechte:", err);
            showMessage("Fehler beim Entfernen der Rechte!");
        }
    };

    if (isLoading) return null;

    return (
        <div className="changePassword" ref={containerRef}>
            <div className="changePasswordModal">
                <div className="topBar">
                    <h5>Rechte anpassen</h5>
                    <button className="closeBtn" onClick={onClose}><CloseIcon /></button>
                </div>
                <form onSubmit={(e) => { e.preventDefault(); handleAddPermissions(); }}>
                    {permissions.map((permission) => (
                        <div className="groupList" key={permission.id}>
                            <span className="role">{permission.role}</span>
                            <div className="right">
                                <span>{moment(permission.createdAt).fromNow()}</span>
                                <RemoveCircleOutlineOutlinedIcon onClick={() => handleDeletePermissions(permission)} />
                            </div>
                        </div>
                    ))}
                    <div className="groupInput">
                        <input
                            type="text"
                            placeholder="Rolle hinzufügen"
                            autoFocus
                            value={role}
                            onChange={(e) => setRole(e.target.value)}
                            onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                    e.preventDefault();
                                    handleAddPermissions();
                                }
                            }}
                        />
                        <AddCircleOutlineOutlinedIcon onClick={handleAddPermissions} />
                    </div>
                    <div className="bottom">
                        <div className="left">
                            <button onClick={onClose} className="light">Abbrechen</button>
                        </div>
                    </div >
                </form >
            </div>
        </div >
    );
};

export default ChangePermissions;